<template>
  <div class="search-conditions">
    <div class="row">
      <div class="col header" style="width:12%">
        <div class="subtitle">거래 날짜 / 시간 (시작)</div>
      </div>
      <div class="col header" style="width:12%">
        <div class="subtitle">거래 날짜 / 시간 (끝)</div>
      </div>
      <div class="col header" style="width:10%">
        <div class="subtitle">승인 결과</div>
      </div>
      <div class="col header" style="width:10%">
        <div class="subtitle">결제 수단</div>
      </div>
      <div class="col header" style="width:10%">
        <div class="subtitle">거래 형태</div>
      </div>
      <div class="col header" style="width:10%">
        <div class="subtitle">상태</div>
      </div>
      <div class="col header one" style="width:36%">
        <div class="subtitle">키워드(주소/장소)</div>
      </div>
    </div>

    <div class="row">
      <div class="col" style="width:12%">
        <date-picker
          type="datetime"
          v-model="startDateTime"
          input-class="datetime"
          style="width: 100%;"
          :show-second="false"
          format="YYYY.MM.DD HH:mm"
          :confirm="true"
          value-type="YYYY.MM.DD HH:mm"
        ></date-picker>
      </div>
      <div class="col" style="width:12%">
        <date-picker
          type="datetime"
          v-model="endDateTime"
          input-class="datetime"
          style="width: 100%;"
          :show-second="false"
          format="YYYY.MM.DD HH:mm"
          :confirm="true"
          value-type="YYYY.MM.DD HH:mm"
        ></date-picker>
      </div>

      <div class="col" style="width:10%">
        <div class="select">
          <select v-model="approveResult">
            <option v-for="item in approveResults" :key="item">
              {{ item }}
            </option>
          </select>

          <img
            v-if="approveResult"
            src="/static/img/ico-close.png"
            @click="approveResult = null"
          />
        </div>
      </div>
      <div class="col" style="width:10%">
        <div class="select">
          <select v-model="paymentMode">
            <option v-for="item in paymentModes" :key="item">
              {{ item }}
            </option>
          </select>

          <img
            v-if="paymentMode"
            src="/static/img/ico-close.png"
            @click="paymentMode = null"
          />
        </div>
      </div>
      <div class="col" style="width:10%">
        <div class="select">
          <select v-model="approveType">
            <option v-for="item in approveTypes" :key="item">
              {{ item }}
            </option>
          </select>

          <img
            v-if="approveType"
            src="/static/img/ico-close.png"
            @click="approveType = null"
          />
        </div>
      </div>
      <div class="col" style="width:10%">
        <div class="select">
          <select v-model="state">
            <option v-for="item in states" :key="item">
              {{ item }}
            </option>
          </select>

          <img
            v-if="state"
            src="/static/img/ico-close.png"
            @click="state = null"
          />
        </div>
      </div>
      <div class="col desc"  style="width:26%">
        <input
          class="span"
          v-model="keyword"
          type="text"
          placeholder="결제 주소 및 장소에 포함된 키워드를 입력해주세요."
        />
      </div>
      <div class="col btn"  style="width:10%">
        <button class="btn blue" @click="search">
          <img src="/static/img/ico-magnify.png" alt />
          결제기록 검색
        </button>
      </div>
      <!-- <div class="col btn">
        <button class="btn orange" @click="download">
          <img src="/static/img/ico-microsoft-excel.png" alt />
          excel 다운로드
        </button>
      </div> -->
    </div>
  </div>
</template>

<script>
/* eslint-disable no-alert */
/* eslint-disable no-param-reassign */
/* eslint-disable no-plusplus */
/* eslint-disable no-useless-escape */
/* eslint-disable no-console */
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

export default {
  components: {
    DatePicker,
  },
  data: () => ({
    startDateTime: null,
    startDate: {
      value: '',
      oldValue: null,
    },
    startTime: null,
    endDateTime: null,
    endDate: {
      value: '',
      oldValue: null,
    },
    endTime: null,
    approveResults: [],
    approveResult: null,
    paymentModes: [],
    paymentMode: null,
    approveTypes: [],
    approveType: null,
    keyword: '',
    searchCondition: '',
    today: null,
    limitDay: null,
    states: [],
    state: null,
  }),
  created() {
    for (let i = 0; i < this.$approveResult.length; i++) {
      this.approveResults.push(this.$approveResult[i].name);
    }

    for (let i = 0; i < this.$paymentMode.length; i++) {
      this.paymentModes.push(this.$paymentMode[i].name);
    }

    for (let i = 0; i < this.$approveType.length; i++) {
      this.approveTypes.push(this.$approveType[i].name);
    }

    for (let i = 0; i < this.$state.length; i++) {
      if (this.$state[i].search) {
        this.states.push(this.$state[i].name);
      }
    }
  },
  mounted() {
    this.search();
  },
  watch: {
    startDateTime: {
      handler() {
        if (this.startDateTime) {
          try {
            const splitDateTime = this.startDateTime.split(' ');
            this.startDate.value = splitDateTime[0];
            this.startTime = splitDateTime[1];
          } catch (e) {
            console.error(e);
          }
        }
      },
    },
    endDateTime: {
      handler() {
        if (this.endDateTime) {
          try {
            const splitDateTime = this.endDateTime.split(' ');
            this.endDate.value = splitDateTime[0];
            this.endTime = splitDateTime[1];
          } catch (e) {
            console.error(e);
          }
        }
      },
    },
  },
  methods: {
    numberAndDotFilter(data) {
      if (/^[\d\.]*$/.test(data.value)) {
        data.oldValue = data.value;
      } else if (data.oldValue) {
        data.value = data.oldValue;
      } else {
        data.value = '';
      }
    },
    search() {
      this.searchCondition = '';
      let startTime = '';
      let endTime = '';
      let approveResult = '';
      let paymentMode = '';
      let approveType = '';
      let state = '';
      let keyword = '';

      if (this.startDate.value) {
        if (!this.isValidDate(this.startDate.value)) {
          alert('올바른 시작 날짜를 입력하세요');
          return;
        }
        startTime = this.$moment(this.convertDate(this.startDate.value)).format();
      }
      if (this.startTime) {
        if (!this.startDate.value) {
          alert('시작 날짜를 입력하세요');
          return;
        }
        if (!this.isValidTime(this.startTime)) {
          alert('올바른 시작 시간을 입력하세요');
          return;
        }
        startTime = this.$moment(
          `${this.convertDate(this.startDate.value)} ${this.startTime}`,
        ).format();
      }

      if (this.endDate.value) {
        if (!this.isValidDate(this.endDate.value)) {
          alert('올바른 끝 날짜를 입력하세요');
          return;
        }
        endTime = this.$moment(`${this.convertDate(this.endDate.value)} 23:59:59`).format();
      }
      if (this.endTime) {
        if (!this.endDate.value) {
          alert('끝 날짜를 입력하세요');
          return;
        }
        if (!this.isValidTime(this.endTime)) {
          alert('올바른 끝 시간을 입력하세요');
          return;
        }
        endTime = this.$moment(
          `${this.convertDate(this.endDate.value)} ${this.endTime}:59`,
        ).format();
      }

      if (this.startDate.value < this.limitDay || this.endDate.value > this.today) {
        alert('최근 7일간의 결제건만 검색하실 수 있습니다.');
        return;
      }

      if (this.approveResult) {
        approveResult = this.$getConstCode('approveResult', this.approveResult);
      }
      if (this.paymentMode) {
        paymentMode = this.$getConstCode('paymentMode', this.paymentMode);
      }
      if (this.approveType) {
        approveType = this.$getConstCode('approveType', this.approveType);
      }

      //
      if (this.state) {
        state = this.$getConstCode('state', this.state);
      }

      if (this.keyword) {
        keyword = this.keyword;
      }

      let searchCondition = '';
      if (startTime) {
        // searchCondition += `&from=${encodeURIComponent(startTime)}`;
        searchCondition += `&from=${encodeURIComponent(new Date(startTime).toISOString())}`;
      }
      if (endTime) {
        // searchCondition += `&to=${encodeURIComponent(endTime)}`;
        searchCondition += `&to=${encodeURIComponent(new Date(endTime).toISOString())}`;
      }
      if (approveResult) {
        searchCondition += `&approveResult=${encodeURIComponent(approveResult)}`;
      }
      if (paymentMode) {
        searchCondition += `&paymentMode=${encodeURIComponent(paymentMode)}`;
      }
      if (approveType) {
        searchCondition += `&approveType=${encodeURIComponent(approveType)}`;
      }

      //
      if (state) {
        if (state === 2) {
          searchCondition += `&state=${state}&state=3`;
        } else if (state === 8) {
          searchCondition += `&state=${state}&state=11`;
        } else if (state === 13) {
          searchCondition += `&state=${state}&state=131`;
        } else {
          searchCondition += `&state=${state}`;
        }
      } else {
        // TODO
        // searchCondition += '&state=1&state=2&state=3&state=4&state=5&state=6&state=7&state=8&state=9&state=10&state=11&state=12&state=101&state=131';
      }

      if (keyword) {
        searchCondition += `&keyword=${encodeURIComponent(keyword)}`;
      }
      this.searchCondition = searchCondition.replace('&', '');

      this.$emit('search', this.searchCondition, startTime, endTime);
    },
    download() {
      this.$emit('download');
    },
    isValidDate(date) {
      if (!/^\d{4}.\d{2}.\d{2}$/.test(date)) {
        return false;
      }

      const parts = date.split('.');
      const year = parseInt(parts[0], 10);
      const month = parseInt(parts[1], 10);
      const day = parseInt(parts[2], 10);

      if (month === 0 || month > 12) {
        return false;
      }

      const monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

      if (year % 400 === 0 || (year % 100 !== 0 && year % 4 === 0)) {
        monthLength[1] = 29;
      }

      return day > 0 && day <= monthLength[month - 1];
    },
    isValidTime(time) {
      if (!/^\d{2}:\d{2}$/.test(time)) {
        return false;
      }

      const parts = time.split(':');
      const hour = parseInt(parts[0], 10);
      const minute = parseInt(parts[1], 10);

      return hour >= 0 && hour < 24 && minute >= 0 && minute < 60;
    },
    convertDate(date) {
      const parts = date.split('.');
      const year = parts[0];
      const month = parts[1];
      const day = parts[2];
      let ret = year;
      ret += '-';
      ret += month;
      ret += '-';
      ret += day;
      return ret;
    },
  },
};
</script>

<style scoped>
.search-conditions .row {
  display: flex;
  height: 40px;
}
.search-conditions .row.space {
  margin-top: 48px;
}
.search-conditions .row .col {
  width: 100%;
  text-align: center;
}

.search-conditions .row .col:not(:last-child) {
  margin-right: 12px;
}

.search-conditions .row .col.header {
  text-align: left;
  margin-left: 10px;
  padding-top: 10px;
}
.search-conditions .row .col.btn {
  max-width: 130px;
}
.search-conditions .title {
  margin-bottom: 26px;
}
.search-conditions .subtitle {
  margin-bottom: 5px;
  font-size: 14.8px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.78;
  letter-spacing: 0.19px;
  color: #212121;
}
.search-conditions input {
  padding: 16px 8px 16px 16px;
  width: 100%;
  height: 100%;
  border: solid 0.5px #686868;
}
.search-conditions input::placeholder {
  font-size: 14.8px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.62;
  letter-spacing: 0.19px;
  color: rgba(72, 72, 72, 0.64);
}
.search-conditions .select {
  position: relative;
}
.search-conditions .select select {
  padding-left: 10px;
  width: 100%;
  height: 40px;
  border: solid 0.5px #686868;
  font-size: 14.8px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.62;
  letter-spacing: 0.19px;
}
.search-conditions .select img {
  position: absolute;
  width: 18px;
  height: 18px;
  top: 50%;
  right: 36px;
  transform: translate(0, -50%);
  cursor: pointer;
}
.search-conditions .btn {
  width: 100%;
  height: 40px;
  text-align: center;
  font-size: 12.8px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  color: #ffffff;
  border-radius: 2px;
  transition: 0.2s;
  cursor: pointer;
}
.search-conditions .btn img {
  width: 24px;
  height: 24px;
  vertical-align: middle;
}
.btn.blue {
  background-color: #0058EE;
}
.btn.blue .btn:hover {
  background-color: #0068fe;
}
.btn.orange {
  background-color: #FC8145;
}
.btn.orange .btn:hover {
  background-color: #FC8100;
}
.btn.redpink {
  background-color: #D01156;
}
.btn.redpink .btn:hover {
  background-color: #D01100;
}
</style>



// WEBPACK FOOTER //
// src/components/payHistory/SearchConditions.vue